export { default, getStaticProps } from "app/conditions-generales/page";
